// Converted from makeStyles to simple style object
const styles = {
    containerForm: {
        marginBottom: "20px",
    },
    formControl: {
        margin: "8px",
        width: "100%",
    },
    selectEmpty: {
        marginTop: "16px",
    },
    paper: {
        padding: "40px",
        margin: "16px",
    },
    avatar: {
        margin: "8px",
    },
    form: {
        marginTop: "8px",
    },
    submit: {
        margin: "24px 0 16px",
        backgroundImage: `linear-gradient(to right, #00d2ff 0%, #3a7bd5  51%, #00d2ff  100%)`,
        backgroundSize: "200% auto",
        display: "block",
        width: "100%",
    },
    chipContainer: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "4px",
        margin: 0,
    },
    chip: {
        margin: "4px",
    },
    selectedServiceChip: {
        fontWeight: "bolder"
    },
    dividerGrid: {
        marginTop: "5px",
        marginBottom: "5px"
    },
    divider: {
        width: "100%",
        height: "10px",
    },
    activityTabContainer: {
        padding: "24px",
    },
    activityTable: {
        marginTop: "16px",
    },
    loginChip: {
        backgroundColor: '#81c784',
        minWidth: 90,
    },
    logoutChip: {
        backgroundColor: '#bdbdbd',
        minWidth: 90,
    }
};

const useStyles = () => styles;
export default useStyles;
